module.exports = __webpack_public_path__ + "img/czech-republic.d49cd95a.svg";